// Nadrama <https://nadrama.com>
// Copyright Nadrama Pty Ltd
// All rights reserved.

const configuredBase = import.meta.env.VITE_API_URL as string | undefined;
const defaultBase = import.meta.env.PROD
  ? "https://api.nadrama.com"
  : "http://localhost:8080";

export const apiBaseUrl = configuredBase ?? defaultBase;
